module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"How to use it?"},"es":{"title":"¿Cómo usarlo?"}}')
  delete Component.options._Ctor
}
